export function replacePlaceholders(
  inputString: string,
  values: string[]
): string {
  return inputString.replace(/{(\d+)}/g, (match, index) => {
    const valueIndex = parseInt(index, 10);
    return values[valueIndex] !== undefined ? values[valueIndex] : match;
  });
}

export function booleanToNumberString(value: boolean): string {
  return value ? "true" : "false";
}

export function convertCentsToDollars(cents: number): number {
  return cents / 100;
}

export async function logFetch(
  url: string,
  options: RequestInit
): Promise<Response> {
  // Log the request details
  console.groupCollapsed("Request Details");
  console.log("URL:", url);
  console.log("Method:", options.method);
  console.log("Headers:", options.headers);
  if (options.body) {
    console.log("Body:", options.body);
  }
  console.groupEnd();

  // Make the fetch request and capture the response
  const response = await fetch(url, options);

  // Log the response details
  console.groupCollapsed("Response Details");
  console.log("Status:", response.status);
  console.log("Status Text:", response.statusText);
  console.log("Headers:", response.headers);
  console.groupEnd();

  // Return the response for further processing
  return response;
}
